import { Box } from '@material-ui/core';
import { Loan } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { isValidProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/Progress/WithProgress/WithProgress';
import { ProgressTimeline } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/Progress/ProgressTimeline/ProgressTimeline';
import { AbstractProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/AbstractProgress';
import { FactoryProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/FactoryProgress';
import { LoadingValuesWarning } from '@/components/modules/Documentation/components/shared/LoadingValuesWarning';
import { Font } from '@/components/shared/components/Font';
import { IconHeader } from '@/components/shared/components/IconHeader';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { ApplicationTypeMap } from '@/config/maps/ApplicationType.map';
import { ApplicationType, StatusTagType } from '@/config/types';
import { STYLE_PARAMS_BY_STATUS } from '@/constants/styleParamsByStatus';

interface ProgressProps {
  loan: Loan;
  applicationType: ApplicationType;
}

export const Progress = ({ loan, applicationType }: ProgressProps) => {
  const [progress, setProgress] = useState<AbstractProgress | undefined>();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const paymentMethodType = ApplicationTypeMap.fromApplicationType(applicationType);
    const progress = FactoryProgress.create(loan.id, paymentMethodType);

    progress
      .calculateProgress()
      .then(() => {
        setProgress(progress);
      })
      .finally(() => setLoading(false));
  }, [loan, applicationType]);

  if (!isValidProgress(progress)) {
    if (loading) {
      return (
        <>
          <Box width={'100%'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} pb={4}>
            <IconHeader labelTid={'PROGRESS'} iconName={'timelapse'} color={'secondary'} />
          </Box>
          <Box>
            <LoadingValuesWarning />
          </Box>
        </>
      );
    }
    return null;
  }

  return (
    <>
      <Box width={'100%'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} pb={4}>
        <IconHeader labelTid={'PROGRESS'} iconName={'timelapse'} color={'secondary'} />
        <Font variant={'h2'} color={'title'}>
          <Box display={'flex'}>
            <StatusTag
              type={
                STYLE_PARAMS_BY_STATUS[progress.currentStep?.status ?? '']?.colorPaletteName ?? StatusTagType.DEFAULT
              }
              colorType={STYLE_PARAMS_BY_STATUS[progress.currentStep?.status]?.colorType}
              labelTextId={progress.currentStep?.nameTextId}
            />
          </Box>
        </Font>
      </Box>
      <Box>
        <ProgressTimeline progress={progress} />
      </Box>
    </>
  );
};
